'use client';

import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TableContainer,
  Typography
} from "@mui/material";
import {
  flexRender,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable
} from "@tanstack/react-table";
import React, { useMemo, useState } from "react";
import "./Table.scss";

import SearchBar from "../../components/Common/Searchbar";
import DateFilter from "../../components/CustomComponents/DateFilter";

export const dummyData = [
  { id: 1, name: "Apex Industries", entity: "Invoice", transactionDate: "2025-02-11", invoiceCount: 3, sales: 18750.50, salesWithTax: 22125.59, gstin: "27APXI1234A1Z5", gstTreatment: "Registered Business - Regular", panNumber: "APXI1234A" },
  { id: 2, name: "Bluewave Solutions", entity: "Credit Note", transactionDate: "2024-11-28", invoiceCount: 1, sales: 9200.00, salesWithTax: 10856.00, gstin: "29BWSL5678B1Z3", gstTreatment: "Special Economic Zone", panNumber: "BWSL5678B" },
  { id: 3, name: "Crestline Foods", entity: "Item", transactionDate: "2025-01-06", invoiceCount: 2, sales: 5400.00, salesWithTax: 6372.00, gstin: "09CRST1111C1Z8", gstTreatment: "Registered Business - Regular", panNumber: "CRST1111C" },
  { id: 4, name: "Digital Nexus", entity: "Invoice", transactionDate: "2024-12-19", invoiceCount: 4, sales: 28500.00, salesWithTax: 33630.00, gstin: "29DNXS2222D1Z9", gstTreatment: "Registered Business - Regular", panNumber: "DNXS2222D" },
  { id: 5, name: "Elite Fabrics", entity: "Credit Note", transactionDate: "2023-10-14", invoiceCount: 2, sales: 7600.00, salesWithTax: 8970.00, gstin: "07ELTF3333E1Z7", gstTreatment: "Registered Business - Regular", panNumber: "ELTF3333E" },
  { id: 6, name: "Falcon Motors", entity: "Invoice", transactionDate: "2024-04-03", invoiceCount: 7, sales: 122000.00, salesWithTax: 143960.00, gstin: "29FLCM4444F1Z6", gstTreatment: "Registered Business - Regular", panNumber: "FLCM4444F" },
  { id: 7, name: "GreenLeaf Organics", entity: "Item", transactionDate: "2025-03-22", invoiceCount: 3, sales: 9700.75, salesWithTax: 11446.89, gstin: "29GRLF5555G1Z1", gstTreatment: "Unregistered Business", panNumber: "" },
  { id: 8, name: "Horizon Architects", entity: "Invoice", transactionDate: "2023-09-17", invoiceCount: 6, sales: 45000.00, salesWithTax: 53100.00, gstin: "29HRZA6666H1Z2", gstTreatment: "Registered Business - Regular", panNumber: "HRZA6666H" },
  { id: 9, name: "Infinium Labs", entity: "Credit Note", transactionDate: "2024-08-05", invoiceCount: 2, sales: 3100.00, salesWithTax: 3658.00, gstin: "29INFN7777I1Z4", gstTreatment: "Registered Business - Regular", panNumber: "INFN7777I" },
  { id: 10, name: "JetStream Tech", entity: "Item", transactionDate: "2025-01-28", invoiceCount: 5, sales: 18700.00, salesWithTax: 22066.00, gstin: "29JSTM8888J1Z6", gstTreatment: "Registered Business - Regular", panNumber: "JSTM8888J" },

  { id: 11, name: "Krypton Systems", entity: "Invoice", transactionDate: "2024-06-30", invoiceCount: 4, sales: 42200.00, salesWithTax: 49796.00, gstin: "29KRPS9999K1Z7", gstTreatment: "Registered Business - Regular", panNumber: "KRPS9999K" },
  { id: 12, name: "Lumina Networks", entity: "Credit Note", transactionDate: "2023-11-11", invoiceCount: 3, sales: 15600.00, salesWithTax: 18408.00, gstin: "29LMNW0001L1Z3", gstTreatment: "Registered Business - Regular", panNumber: "LMNW0001L" },
  { id: 13, name: "Mosaic Interiors", entity: "Item", transactionDate: "2025-02-01", invoiceCount: 1, sales: 2900.00, salesWithTax: 3422.00, gstin: "", gstTreatment: "Unregistered Business", panNumber: "" },
  { id: 14, name: "Nova Health", entity: "Invoice", transactionDate: "2024-09-19", invoiceCount: 7, sales: 78000.00, salesWithTax: 92040.00, gstin: "29NVHL1212M1Z1", gstTreatment: "Registered Business - Regular", panNumber: "NVHL1212M" },
  { id: 15, name: "Optima Solutions", entity: "Credit Note", transactionDate: "2025-03-08", invoiceCount: 1, sales: 6200.00, salesWithTax: 7316.00, gstin: "29OPTS1313N1Z2", gstTreatment: "Registered Business - Regular", panNumber: "OPTS1313N" },
  { id: 16, name: "Prime Elevators", entity: "Item", transactionDate: "2024-07-02", invoiceCount: 2, sales: 8400.00, salesWithTax: 9912.00, gstin: "29PRME1414P1Z4", gstTreatment: "Registered Business - Regular", panNumber: "PRME1414P" },
  { id: 17, name: "Quantum Foods", entity: "Invoice", transactionDate: "2025-04-12", invoiceCount: 5, sales: 23300.00, salesWithTax: 27574.00, gstin: "29QNFD1515Q1Z8", gstTreatment: "Registered Business - Regular", panNumber: "QNFD1515Q" },
  { id: 18, name: "RedRock Builders", entity: "Credit Note", transactionDate: "2024-02-18", invoiceCount: 2, sales: 51000.00, salesWithTax: 60180.00, gstin: "29RDBL1616R1Z9", gstTreatment: "Registered Business - Regular", panNumber: "RDBL1616R" },
  { id: 19, name: "Skyline Traders", entity: "Invoice", transactionDate: "2023-12-07", invoiceCount: 4, sales: 13700.00, salesWithTax: 16166.00, gstin: "29SKYL1717S1Z2", gstTreatment: "Registered Business - Regular", panNumber: "SKYL1717S" },
  { id: 20, name: "Trident Media", entity: "Item", transactionDate: "2024-03-15", invoiceCount: 3, sales: 7400.00, salesWithTax: 8732.00, gstin: "", gstTreatment: "Unregistered Business", panNumber: "" },

  { id: 21, name: "Urban Estates", entity: "Invoice", transactionDate: "2025-03-29", invoiceCount: 6, sales: 89200.00, salesWithTax: 105056.00, gstin: "29URBN1818T1Z5", gstTreatment: "Registered Business - Regular", panNumber: "URBN1818T" },
  { id: 22, name: "Vortex Energy", entity: "Credit Note", transactionDate: "2023-08-14", invoiceCount: 1, sales: 7800.00, salesWithTax: 9204.00, gstin: "29VRTX1919U1Z3", gstTreatment: "Registered Business - Regular", panNumber: "VRTX1919U" },
  { id: 23, name: "WaveTech Labs", entity: "Item", transactionDate: "2024-11-26", invoiceCount: 2, sales: 3600.00, salesWithTax: 4248.00, gstin: "29WTEC2020V1Z1", gstTreatment: "Registered Business - Regular", panNumber: "WTEC2020V" },
  { id: 24, name: "Xeno Pharmatech", entity: "Invoice", transactionDate: "2025-01-13", invoiceCount: 9, sales: 101000.00, salesWithTax: 119180.00, gstin: "29XNPH2121W1Z7", gstTreatment: "Registered Business - Regular", panNumber: "XNPH2121W" },
  { id: 25, name: "YellowPeak Services", entity: "Credit Note", transactionDate: "2024-05-09", invoiceCount: 3, sales: 31000.00, salesWithTax: 36580.00, gstin: "29YPSV2222X1Z6", gstTreatment: "Registered Business - Regular", panNumber: "YPSV2222X" },
  { id: 26, name: "Zenith Consulting", entity: "Invoice", transactionDate: "2023-07-22", invoiceCount: 4, sales: 12800.00, salesWithTax: 15104.00, gstin: "29ZNTH2323Y1Z8", gstTreatment: "Registered Business - Regular", panNumber: "ZNTH2323Y" },
  { id: 27, name: "Aurora Fitness", entity: "Item", transactionDate: "2025-02-20", invoiceCount: 2, sales: 5600.00, salesWithTax: 6608.00, gstin: "", gstTreatment: "Unregistered Business", panNumber: "" },
  { id: 28, name: "Brightwave Studios", entity: "Invoice", transactionDate: "2024-10-30", invoiceCount: 6, sales: 47000.00, salesWithTax: 55460.00, gstin: "29BRWS2424Z1Z3", gstTreatment: "Registered Business - Regular", panNumber: "BRWS2424Z" },
  { id: 29, name: "CyberCore Pvt Ltd", entity: "Credit Note", transactionDate: "2023-12-18", invoiceCount: 1, sales: 9100.00, salesWithTax: 10738.00, gstin: "29CBCR2525A1Z1", gstTreatment: "Registered Business - Regular", panNumber: "CBCR2525A" },
  { id: 30, name: "Driftwood Solutions", entity: "Item", transactionDate: "2024-09-05", invoiceCount: 5, sales: 12900.00, salesWithTax: 15282.00, gstin: "29DWDS2626B1Z9", gstTreatment: "Registered Business - Regular", panNumber: "DWDS2626B" },

  { id: 31, name: "Elemental Hardware", entity: "Invoice", transactionDate: "2025-04-04", invoiceCount: 3, sales: 4400.00, salesWithTax: 5192.00, gstin: "29ELHW2727C1Z5", gstTreatment: "Registered Business - Regular", panNumber: "ELHW2727C" },
  { id: 32, name: "Futura Technologies", entity: "Credit Note", transactionDate: "2023-10-01", invoiceCount: 2, sales: 18300.00, salesWithTax: 21654.00, gstin: "29FTRT2828D1Z4", gstTreatment: "Registered Business - Regular", panNumber: "FTRT2828D" },
  { id: 33, name: "Glow Media Pvt Ltd", entity: "Item", transactionDate: "2024-12-21", invoiceCount: 4, sales: 7600.00, salesWithTax: 8984.00, gstin: "", gstTreatment: "Unregistered Business", panNumber: "" },
  { id: 34, name: "Helix Biotech", entity: "Invoice", transactionDate: "2024-06-19", invoiceCount: 6, sales: 32900.00, salesWithTax: 38822.00, gstin: "29HLXB2929E1Z7", gstTreatment: "Registered Business - Regular", panNumber: "HLXB2929E" },
  { id: 35, name: "Indigo Creations", entity: "Credit Note", transactionDate: "2023-09-18", invoiceCount: 3, sales: 15800.00, salesWithTax: 18644.00, gstin: "29INDC3030F1Z5", gstTreatment: "Registered Business - Regular", panNumber: "INDC3030F" },
  { id: 36, name: "Jupiter Labs", entity: "Item", transactionDate: "2025-03-18", invoiceCount: 1, sales: 2900.00, salesWithTax: 3422.00, gstin: "29JPLB3131G1Z1", gstTreatment: "Registered Business - Regular", panNumber: "JPLB3131G" },
  { id: 37, name: "Kite Apparel Co", entity: "Invoice", transactionDate: "2024-01-27", invoiceCount: 4, sales: 10200.00, salesWithTax: 12036.00, gstin: "29KTAP3232H1Z3", gstTreatment: "Registered Business - Regular", panNumber: "KTAP3232H" },
  { id: 38, name: "Lumen Dynamics", entity: "Credit Note", transactionDate: "2023-08-26", invoiceCount: 2, sales: 14200.00, salesWithTax: 16756.00, gstin: "29LMDN3333I1Z6", gstTreatment: "Registered Business - Regular", panNumber: "LMDN3333I" },
  { id: 39, name: "MediCore Solutions", entity: "Item", transactionDate: "2025-02-07", invoiceCount: 1, sales: 3500.00, salesWithTax: 4130.00, gstin: "", gstTreatment: "Unregistered Business", panNumber: "" },
  { id: 40, name: "Nimbus Electronics", entity: "Invoice", transactionDate: "2024-10-02", invoiceCount: 6, sales: 72500.00, salesWithTax: 85550.00, gstin: "29NMBE3434J1Z8", gstTreatment: "Registered Business - Regular", panNumber: "NMBE3434J" },

  { id: 41, name: "Opal Interiors", entity: "Credit Note", transactionDate: "2023-12-03", invoiceCount: 1, sales: 6200.00, salesWithTax: 7316.00, gstin: "29OPLT3535K1Z2", gstTreatment: "Registered Business - Regular", panNumber: "OPLT3535K" },
  { id: 42, name: "Prime Agro Foods", entity: "Item", transactionDate: "2024-07-29", invoiceCount: 7, sales: 18700.00, salesWithTax: 22066.00, gstin: "29PRAG3636L1Z5", gstTreatment: "Registered Business - Regular", panNumber: "PRAG3636L" },
  { id: 43, name: "Quest Digital", entity: "Invoice", transactionDate: "2025-04-18", invoiceCount: 5, sales: 34000.00, salesWithTax: 40120.00, gstin: "29QSTD3737M1Z4", gstTreatment: "Registered Business - Regular", panNumber: "QSTD3737M" },
  { id: 44, name: "RedVibe Retail", entity: "Credit Note", transactionDate: "2024-03-09", invoiceCount: 3, sales: 12700.00, salesWithTax: 14986.00, gstin: "29RDVB3838N1Z1", gstTreatment: "Registered Business - Regular", panNumber: "RDVB3838N" },
  { id: 45, name: "StoneWorks Ltd", entity: "Item", transactionDate: "2023-10-24", invoiceCount: 2, sales: 4700.00, salesWithTax: 5546.00, gstin: "29STWK3939P1Z6", gstTreatment: "Registered Business - Regular", panNumber: "STWK3939P" },
  { id: 46, name: "TechNova Labs", entity: "Invoice", transactionDate: "2024-05-31", invoiceCount: 8, sales: 52900.00, salesWithTax: 62422.00, gstin: "29TNLB4040Q1Z3", gstTreatment: "Registered Business - Regular", panNumber: "TNLB4040Q" },
  { id: 47, name: "Urban Hive", entity: "Credit Note", transactionDate: "2023-08-22", invoiceCount: 1, sales: 4500.00, salesWithTax: 5310.00, gstin: "29URHV4141R1Z9", gstTreatment: "Registered Business - Regular", panNumber: "URHV4141R" },
  { id: 48, name: "VisionOptics", entity: "Item", transactionDate: "2024-09-14", invoiceCount: 6, sales: 14300.00, salesWithTax: 16874.00, gstin: "29VSOP4242S1Z5", gstTreatment: "Registered Business - Regular", panNumber: "VSOP4242S" },
  { id: 49, name: "Windsor Traders", entity: "Invoice", transactionDate: "2023-11-27", invoiceCount: 4, sales: 21500.00, salesWithTax: 25370.00, gstin: "29WNDR4343T1Z8", gstTreatment: "Registered Business - Regular", panNumber: "WNDR4343T" },
  { id: 50, name: "ZenLife Pharma", entity: "Credit Note", transactionDate: "2024-02-04", invoiceCount: 2, sales: 32000.00, salesWithTax: 37760.00, gstin: "29ZNLP4444U1Z1", gstTreatment: "Registered Business - Regular", panNumber: "ZNLP4444U" }
];

const ENTITY_OPTIONS = ["Invoice", "Credit Note", "Item"];
const defaultPageSize = 10;

export default function EntitiesTable() {
  // Applied filter states
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedEntities, setSelectedEntities] = useState(ENTITY_OPTIONS);
  const [dateFilter, setDateFilter] = useState({
    start: null,
    end: null,
    preset: "This Year",
    isCustom: false,
  });

  // Temporary filter states (before applying)
  const [tempSearchTerm, setTempSearchTerm] = useState("");
  const [tempSelectedEntities, setTempSelectedEntities] = useState(ENTITY_OPTIONS);
  const [tempDateFilter, setTempDateFilter] = useState({
    start: null,
    end: null,
    preset: "This Year",
    isCustom: false,
  });

  const [resetSignal, setResetSignal] = useState(0);
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: defaultPageSize
  });

  const columns = useMemo(() => [
    {
      accessorKey: "name",
      header: "Name",
      enableSorting: true
    },
    {
      accessorKey: "transactionDate",
      header: "Date",
      enableSorting: true
    },
    {
      accessorKey: "invoiceCount",
      header: "Invoice",
      enableSorting: true
    },
    {
      accessorKey: "sales",
      header: "Sales",
      enableSorting: true
    },
    {
      accessorKey: "salesWithTax",
      header: "Sales (with tax)",
      enableSorting: true
    },
    {
      accessorKey: "gstin",
      header: "GSTIN",
      enableSorting: false
    },
    {
      accessorKey: "gstTreatment",
      header: "GST Treatment",
      enableSorting: false
    },
    {
      accessorKey: "panNumber",
      header: "PAN",
      enableSorting: false
    }
  ], []);

  function parseLocalDate(dateString) {
    if (!dateString) return null;
    const [year, month, day] = dateString.split("-").map(Number);
    const d = new Date(year, month - 1, day);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  const filteredRows = useMemo(() => {
    let rows = [...dummyData];

    if (searchTerm.trim()) {
      const s = searchTerm.toLowerCase();
      rows = rows.filter(r =>
        r.name.toLowerCase().includes(s) ||
        r.entity.toLowerCase().includes(s) ||
        (r.gstin && r.gstin.toLowerCase().includes(s)) ||
        (r.panNumber && r.panNumber.toLowerCase().includes(s))
      );
    }

    if (selectedEntities.length < ENTITY_OPTIONS.length) {
      rows = rows.filter(r => selectedEntities.includes(r.entity));
    }

    if (dateFilter.start && dateFilter.end) {
      rows = rows.filter(r => {
        const d = parseLocalDate(r.transactionDate);
        return d >= dateFilter.start && d <= dateFilter.end;
      });
    }

    return rows;
  }, [searchTerm, selectedEntities, dateFilter]);

  const table = useReactTable({
    data: filteredRows,
    columns,
    state: { sorting, pagination },
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getPaginationRowModel: getPaginationRowModel()
  });

  const handleEntityChange = (e) => {
    const v = e.target.value;
    setTempSelectedEntities(typeof v === "string" ? v.split(",") : v);
  };

  const applyFilters = (searchValueOverride = null) => {
    const searchToApply = searchValueOverride !== null ? searchValueOverride : tempSearchTerm;
    setSearchTerm(searchToApply);
    setTempSearchTerm(searchToApply);
    setSelectedEntities(tempSelectedEntities);
    setDateFilter(tempDateFilter);
    setPagination({ ...pagination, pageIndex: 0 });
  };

  const resetFilters = () => {
    setSearchTerm("");
    setSelectedEntities(ENTITY_OPTIONS);
    setDateFilter({
      start: null,
      end: null,
      preset: "This Year",
      isCustom: false,
    });
    setTempSearchTerm("");
    setTempSelectedEntities(ENTITY_OPTIONS);
    setTempDateFilter({
      start: null,
      end: null,
      preset: "This Year",
      isCustom: false,
    });
    setResetSignal(prev => prev + 1);
    setPagination({ pageIndex: 0, pageSize: defaultPageSize });
  };

  return (
    <Box p={3}>
      <Typography variant="h5" mb={2}>Entities Table</Typography>

      {/* 🔍 FILTER BAR */}
      <Box display="flex" gap={2} alignItems="center" mb={3} flexWrap="wrap">

        {/* Search */}
        <SearchBar
          onSearch={setTempSearchTerm}
          placeholder="Search Name, GSTIN, PAN, Entity"
          resetSignal={resetSignal}
          onApply={applyFilters}
        />

        {/* Date Filter Component */}
        <DateFilter onDateChange={setTempDateFilter} resetSignal={resetSignal} />

        {/* Entity Filter */}
        <FormControl size="small" sx={{ minWidth: 220 }}>
          <InputLabel>Entities</InputLabel>

          <Select
            multiple
            value={tempSelectedEntities}
            onChange={handleEntityChange}
            input={<OutlinedInput label="Entities" />}
            renderValue={(sel) => sel.join(", ")}
            MenuProps={{
              PaperProps: {
                sx: {
                  "& .MuiMenuItem-root": {
                    paddingTop: "2px",
                    paddingBottom: "2px",
                    paddingX: '0px',
                    height: "32px",
                  },
                },
              },
            }}
          >
            {ENTITY_OPTIONS.map((opt) => (
              <MenuItem
                key={opt}
                value={opt}
                sx={{
                  paddingTop: "4px",
                  paddingBottom: "4px",
                  minHeight: "32px",
                }}
              >
                <Checkbox checked={tempSelectedEntities.includes(opt)} />
                <ListItemText primary={opt} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button sx={{ backgroundColor: '#0053FF' }} variant="contained" onClick={() => applyFilters()}>
          Apply
        </Button>

        <Button sx={{ color: '#0053FF', borderColor: '#0053FF' }} variant="outlined" onClick={resetFilters}>
          Reset
        </Button>

      </Box>

      {/* Showing results */}
      <Typography variant="body2" mb={2}>
        Showing <strong>{filteredRows.length}</strong> results
      </Typography>

      {/* TABLE */}
      <TableContainer className="table-wrapper scroll-area">
        <table>
          <thead>
            {table.getHeaderGroups().map(hg => (
              <tr key={hg.id}>
                {hg.headers.map(header => {
                  const sortable = header.column.columnDef.enableSorting;
                  const colId = header.column.id;

                  return (
                    <th
                      key={header.id}
                      onClick={
                        sortable
                          ? () => {
                            const existing = sorting.find(s => s.id === colId);
                            if (!existing) setSorting([{ id: colId, desc: false }]);
                            else if (!existing.desc)
                              setSorting([{ id: colId, desc: true }]);
                            else setSorting([]);
                            setPagination({ ...pagination, pageIndex: 0 });
                          }
                          : undefined
                      }
                      style={{
                        cursor: sortable ? "pointer" : "default",
                        textAlign: "left",
                        backgroundColor: '#0053FF'
                      }}
                    >
                      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}

                        {sortable && (
                          sorting.length && sorting[0].id === colId ? (
                            sorting[0].desc ? (
                              <ArrowDownward fontSize="small" />
                            ) : (
                              <ArrowUpward fontSize="small" />
                            )
                          ) : (
                            <ArrowUpward fontSize="small" sx={{ opacity: 0.5 }} />
                          )
                        )}
                      </div>
                    </th>
                  );
                })}
              </tr>
            ))}
          </thead>

          <tbody>
            {table.getRowModel().rows.length ? (
              table.getRowModel().rows.map(row => (
                <tr key={row.id}>
                  {row.getVisibleCells().map(cell => {
                    const rightAlign = ["invoiceCount", "sales", "salesWithTax"].includes(
                      cell.column.id
                    );

                    return (
                      <td
                        key={cell.id}
                        style={{ textAlign: rightAlign ? "right" : "left" }}
                      >
                        {cell.column.id === "transactionDate"
                          ? new Date(cell.getValue()).toLocaleDateString()
                          : flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: "center", padding: 20 }}>
                  No data available
                </td>
              </tr>
            )}
          </tbody>

          {/* Pagination */}
          <tfoot>
            <tr>
              <td colSpan={columns.length} style={{ textAlign: "right", paddingTop: 12 }}>
                <Button
                  onClick={() => table.previousPage()}
                  disabled={!table.getCanPreviousPage()}
                  sx={{ mr: 1, color: '#0053FF' }}
                >
                  Prev
                </Button>

                <span style={{ marginRight: 8 }}>
                  Page {pagination.pageIndex + 1} of {table.getPageCount()}
                </span>

                <Button
                  onClick={() => table.nextPage()}
                  disabled={!table.getCanNextPage()}
                  sx={{ ml: 1, color: '#0053FF' }}
                >
                  Next
                </Button>

                <span style={{ marginLeft: 16, marginRight: 8 }}>
                  Rows per page:
                </span>

                <FormControl size="small" sx={{ width: 90 }}>
                  <Select
                    value={pagination.pageSize}
                    onChange={(e) =>
                      setPagination({
                        pageIndex: 0,
                        pageSize: Number(e.target.value)
                      })
                    }
                  >
                    {[5, 10, 20, 50, 100].map(n => (
                      <MenuItem key={n} value={n}>
                        {n}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </td>
            </tr>
          </tfoot>
        </table>
      </TableContainer>
    </Box>
  )
}